import { supabase, BloodGroup } from '../lib/supabase';
import { getTenantId } from '../contexts/TenantContext';

export const bloodGroupService = {
  async getAll(): Promise<BloodGroup[]> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('blood_groups')
      .select('*')
      .eq('tenant_id', tenantId)
      .is('deleted_at', null)
      .order('name', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async getById(id: string): Promise<BloodGroup | null> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('blood_groups')
      .select('*')
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .is('deleted_at', null)
      .single();

    if (error) throw error;
    return data;
  },

  async create(bloodGroup: Omit<BloodGroup, 'id' | 'tenant_id' | 'created_at' | 'updated_at' | 'deleted_at'>): Promise<BloodGroup> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('blood_groups')
      .insert({ ...bloodGroup, tenant_id: tenantId })
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async update(id: string, bloodGroup: Partial<BloodGroup>): Promise<BloodGroup> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('blood_groups')
      .update(bloodGroup)
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async delete(id: string): Promise<void> {
    const tenantId = getTenantId();
    const { error } = await supabase
      .from('blood_groups')
      .update({ deleted_at: new Date().toISOString() })
      .eq('id', id)
      .eq('tenant_id', tenantId);

    if (error) throw error;
  },

  async seedDefaultBloodGroups(): Promise<void> {
    const tenantId = getTenantId();
    const { error } = await supabase.rpc('seed_blood_groups_for_tenant', {
      p_tenant_id: tenantId
    });

    if (error) throw error;
  }
};
